import SearchAndFilters from 'components/SearchAndFilters';
import { FilterConfig } from 'components/SearchAndFilters/FilterTypes';
import { useAtomValue, useSetAtom } from 'jotai';
import { showInfoToast, showSuccessToast } from 'lib/ToastHelper';
import React, { Suspense } from 'react';
import { Row, Col } from 'reactstrap';
import { companyIdAtom } from 'views/state';
import {
  checkedListAtom,
  filterValuesAtom,
  orderingAtom,
  useOnFilterChangeResetAtoms,
} from './state';
import { useEPListFilterValue } from '../hooks';
import { epRefreshAtom } from '../state';

const Filters: React.FC<{ filtersConfig: FilterConfig }> = ({
  filtersConfig,
}) => {
  const companyId = useAtomValue(companyIdAtom);
  const checkedList = useAtomValue(checkedListAtom);
  const ordering = useAtomValue(orderingAtom);
  const setEPRefresh = useSetAtom(epRefreshAtom);
  const onSuccessBulkAlias = (response) => {
    setEPRefresh(Math.random().toString());
    if (response['endpoint_alias_csv'] === response['endpoint_alias_updated'])
      showSuccessToast(response['message']);
    else showInfoToast(response['message']);
  };
  const setFilterValues = useSetAtom(filterValuesAtom);
  const searchPhrase = useEPListFilterValue<string>('search');
  const scannerType = useEPListFilterValue<'Internal' | 'External' | 'EC2'>(
    'scanner_type',
  );
  const selectedEndpointsFilter = useEPListFilterValue<
    'active' | 'aging' | 'deleted'
  >('filter');
  const resetOnFilterChangeAtoms = useOnFilterChangeResetAtoms();
  const handleFilterChange = () => {
    setFilterValues({ ...filtersConfig.getActiveFilterValues() });
    resetOnFilterChangeAtoms();
  };

  return (
    <Suspense fallback={<></>}>
      <Row className="text-left">
        <Col xs="12" md>
          <SearchAndFilters
            config={filtersConfig}
            onChange={handleFilterChange}
          />
        </Col>
      </Row>
    </Suspense>
  );
};

export default Filters;
